import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-c4-four-three',
  templateUrl: './c4-four-three.component.html',
  styleUrls: ['./c4-four-three.component.scss']
})
export class C4FourThreeComponent implements OnInit {
  @HostListener("click") onClick(){
    this.checkRoute();
  }
  fullWidth=false;
  showSideMenu = true;
  constructor() { }

  ngOnInit(): void {
    this.checkRoute();
  }

  splitUrl(){
    let url=location.pathname.split('/');
    // console.log(url);
    if(url.length === 5 || (url.length === 6 && url[5]=== '4-3-1')){
      this.showSideMenu=true;
      this.fullWidth=false;
    }
    else{
      this.showSideMenu=false;
      this.fullWidth=true;
    }
  }
  checkRoute(){
    setTimeout(()=>{
      this.splitUrl();
    })
  }
}
